module.exports = __webpack_public_path__ + "static/media/s-Sum of.4165babd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s-Sum of.png
// module id = 184
// module chunks = 0